import { render, staticRenderFns } from "./AvatarOptionGrid.vue?vue&type=template&id=acebb0d2&"
import script from "./AvatarOptionGrid.vue?vue&type=script&lang=js&"
export * from "./AvatarOptionGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports